import { Type } from "class-transformer";
import { AbstractJSONModel } from "./master-model";
export interface INormPeriod {
  start_date: Date;
  end_date: Date;
  name: string;
  norm_period_type_id: number;
  index: number;
}

export class NormPeriod extends AbstractJSONModel implements INormPeriod {
  @Type(() => Date)
  public start_date: Date = new Date();
  @Type(() => Date)
  public end_date: Date = new Date();
  public name = "";
  public norm_period_type_id = -1;
  public index = -1;
}
